var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sparkline',{attrs:{"height":"36","padding":"4","auto-draw":"","auto-draw-duration":1000,"value":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }